export default __webpack_public_path__ + "static/media/learning_2.707b2c20.svg";